import React, {Component} from 'react';
import * as firebase from 'firebase';
import FontAwesome from 'react-fontawesome';
import logo from './vexpo-logo.svg';
import './auth.css';

export default class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = { user: null, alert: "" }
    this.handleSignIn = this.handleSignIn.bind(this);
    this.handleLostPassword = this.handleLostPassword.bind(this);
  }
  handleSignIn(event) {
    event.preventDefault();
    const auth = firebase.auth();
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;
    auth.signInWithEmailAndPassword(email, password)
      .catch(e => this.setState({alert: e.message}));
  }
  handleLostPassword(event) {
    event.preventDefault();
    const auth = firebase.auth();
    const email = document.getElementById('email').value;
    if(!email) {
      this.setState({alert: "You must enter an email to reset your password."});
      return;
    }
    auth.sendPasswordResetEmail(email)
      .then(() => this.setState({alert: "A reset link has been sent to your email."}))
      .catch(e => this.setState({alert: e.message}));
  }
  componentDidMount() {
    firebase.auth().onAuthStateChanged( firebaseUser => {
      this.setState({user: firebaseUser});
      console.log('user', this.state.user);
    });
  }
  /** @function
   * Requires user to be logged in to view.
   * Otherwise, renders the login.
   */
  render() {
    if(this.state.user){
      return (
        <div>
          {this.props.children}
        </div>
      );
    } else {
      return (
        <div className="login-wrapper">
          <div className="login-panel">
            <div>
              <img src={logo} className="app-logo" alt="logo" />
            </div>
            <div>
              <div className="input-group">
                <label htmlFor="email">Email</label>
                <input id="email" name="email" type="email"/>
              </div>
              <div className="input-group">
                <label htmlFor="password">Password</label>
                <input id="password" name="password" type="password"/>
              </div>
              <div className="input-group centered">
                <button onClick={this.handleLostPassword}>
                  Forgot Password
                </button>
                <button onClick={this.handleSignIn}>
                  Sign In
                  <FontAwesome name="sign-in"/>
                </button>
              </div>
              <div className="alert">
                {this.state.alert}
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/auth/auth.js